import { h, mount, errMsg } from '../ui/dom';
import { api } from '../api';

interface Srv { code: string; name: string; region: string; status: string; capacity: number; online: number; maintenance: string | null }

/** Đo độ trễ thật (RTT trung vị của 3 lần ping). */
async function ping(): Promise<number> {
  const xs: number[] = [];
  for (let i = 0; i < 3; i++) { const t = performance.now(); await fetch('/api/v1/servers/ping', { cache: 'no-store' }); xs.push(performance.now() - t); }
  return Math.round(xs.sort((a, b) => a - b)[1]);
}

export function serverScreen(): Promise<string> {
  return new Promise(async (resolve) => {
    const list = h('div', { class: 'list' }, h('p', { class: 'muted' }, 'Đang tải danh sách máy chủ…'));
    const err = h('div', { class: 'err' });
    mount(h('div', { class: 'screen', style: 'background:radial-gradient(ellipse at 50% 30%,#3a1410,#0c0607 70%)' },
      h('div', { class: 'panel modal' }, h('h2', {}, 'Chọn máy chủ'), h('div', { class: 'ornament' }), list, err)));
    try {
      const [servers, last] = await Promise.all([api<Srv[]>('/servers'), api<{ code: string | null }>('/servers/last')]);
      const rtt = await ping().catch(() => null);
      const remembered = last.code ?? localStorage.getItem('dn.server');
      list.replaceChildren(...servers.map((s) => {
        const ok = s.status === 'ONLINE' || s.status === 'BUSY';
        const load = s.online / s.capacity;
        return h('button', { class: `row ${s.code === remembered ? 'on' : ''}`, disabled: !ok, onClick: async () => {
          try { await api('/servers/select', { body: { code: s.code } }); localStorage.setItem('dn.server', s.code); resolve(s.code); } catch (e) { err.textContent = errMsg(e); }
        } },
          h('div', { class: 'grow' }, h('b', {}, s.name), h('div', { class: 'small-t muted' }, ok ? `${s.online}/${s.capacity} người đang online · ${load > 0.8 ? 'Đông' : 'Ổn định'}` : s.maintenance ?? 'Đang bảo trì')),
          h('span', { class: `badge ${ok ? 'ok' : 'warn'}` }, ok ? (rtt !== null ? `${rtt} ms` : 'Online') : 'Bảo trì'));
      }));
    } catch (e) { err.textContent = errMsg(e); }
  });
}
